import classNames from 'classnames';

export interface IEmoList {
  items: string[];
  selectedEmo?: string[];
  onEmotionClick?: (emo: string, selected: string[]) => void;
}

export const EmoList = ({ items, selectedEmo, onEmotionClick }: IEmoList) => {
  return (
    <div>
      <div className="flex md:flex-col gap-[15px_12px] flex-wrap items-center">
        {items.map((item, idx) => (
          <div
            key={`${item}-idx`}
            className={classNames(
              'w-full max-w-[240px] 2xl:max-w-[360px] rounded-[5px] py-[2px] px-0 lg:p-[5px_10px] text-center text-[16px] font-semibold mx-auto border cursor-pointer transition-all duration-150',
              {
                'bg-blackBaseOpacity20 text-white border-transparent hover:border-[#D3B364]': !(
                  selectedEmo && selectedEmo.includes(item)
                ),
                'bg-[#D3B364] text-[#2C3038] border-[#B28E38] shadow-[0_0_0_2px_rgba(211,179,100,0.25)] hover:border-[#9A7623]':
                  selectedEmo && selectedEmo.includes(item),
              },
            )}
            onClick={onEmotionClick && selectedEmo ? () => onEmotionClick(item, selectedEmo) : undefined}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};
